// Aziende partner di DonnaImpresa — dati reali, aggiornabili a mano.
export const PARTNERS = [
  {
    id: "bcnext",
    nome: "BC NEXT",
    tier: "Partner tecnologico",
    settore: "Consulenza IT & sviluppo software",
    descrizione:
      "Ha progettato e sviluppato la piattaforma DonnaImpresa: identità visiva, sviluppo full-stack, sicurezza e crescita digitale.",
    sito: "https://www.bcnext.it/",
    logo: "/bcnext-logo.png",
    logoDark: true,
  },
  {
    id: "3f-formazione",
    nome: "3F — Centro Formazione",
    tier: "Partner formazione",
    settore: "Centro di formazione accreditato — Frosinone",
    descrizione:
      "Centro di formazione accreditato ARES 118 e affiliato American Heart Association: corsi BLS-D, percorsi per istruttori AHA e defibrillatori DAE.",
    sito: "https://www.3formazione.it/",
    logo: "/3formazione-logo.png",
    logoDark: false,
  },
];
